export const SET_TEST_ALL_DATA = 'SET_TEST_ALL_DATA';
export const SET_TEST_NAME = 'SET_TEST_NAME';
export const SET_TEST_TYPE = 'SET_TEST_TYPE';
export const SET_TEST_WELCOME = 'SET_TEST_WELCOME';
export const SET_TEST_FINAL = 'SET_TEST_FINAL';
export const SET_TEST_TAGS = 'SET_TEST_TAGS';
export const SET_TEST_ID = 'SET_TEST_ID';
export const SET_TEST_SCORE = 'SET_TEST_SCORE';
export const CLEAR_TEST = 'CLEAR_TEST';
export const SET_SHOW_ANSWERS = 'SET_TRUE_ANSWERS';
export const SET_SHOW_POINTS = 'SET_SCORE_POINTS';
export const SET_CRON_STARTED = 'SET_CRON_STARTED';
export const SET_CRON_FINISHED = 'SET_CRON_FINISHED';
export const SET_TYPE_COUNTER = 'SET_TYPE_COUNTER';
